export default __webpack_public_path__ + "static/media/04-technology_preview.e72c0902.jpg";